module.exports = __webpack_public_path__ + "images/assets/69eea66ca4baf0b2162a630d8f7fad15.svg";